module.exports = __webpack_public_path__ + "img/iInformation_image.f497f0de.jpg";